import React, { Fragment } from "react";
import { useEffect } from "react";
import { priceItem } from "../../data/data";
import { useStateContext } from "../../context/contextProvider";

const PriceItem = () => {
  const {getAllProductsAndCategory , dataProducts ,  dataProductsLoading , dataProductsErrMsg , dataProductsShowErrMsg } = useStateContext();
  useEffect( () => {
    window.scrollTo(0, 0);
    getAllProductsAndCategory();
  } , [])
  return (
    <div className=" tw-mt-[150px] tw-w-full tw-overflow-hidden">
      <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-my-4">
         <span className="tw-text-second-zain tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">قائمة الاسعار</span>
      </div>
      <div className="tw-flex tw-flex-col">
        <div className="tw-overflow-x-auto sm:-tw-mx-6 lg:-tw-mx-8">
          <div className="tw-py-4 tw-min-w-full sm:tw-px-6 lg:tw-px-8 tw-flex tw-justify-center tw-items-center">
            <div className="tw-overflow-auto tw-shadow-md tw-w-[80%] sm:tw-w-[95%] tw-max-h-[900px] tw-border-t-2 tw-border-second-zain tw-rounded-md">
              <table className="tw-min-w-full tw-text-center">
                <thead className="tw-border-b navbar-bg ">
                  <tr>
                    <th
                      scope="col"
                      className="tw-text-sm tw-font-medium tw-text-white tw-cursor-pointer tw-px-6 tw-py-4"
                    >
                      المنتج
                    </th>
                    <th
                      scope="col"
                      className="tw-text-sm tw-font-medium tw-text-white tw-cursor-pointer tw-px-6 tw-py-4"
                    >
                      السعر
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    dataProductsLoading ?
                    dataProducts.length == 0 ?    
        <tr className="tw-bg-white hover:tw-bg-red-50 tw-border-b tw-font-cairo tw-cursor-pointer tw-transition-all tw-duration-300 tw-ease-linear">
           <td colSpan="3" className="tw-text-sm tw-font-semibold tw-text-red-500 tw-px-6 tw-py-7 tw-whitespace-nowrap">
            عذرا لم يتم اضافة المواد 
           </td>
           </tr> 
           :
                  dataProducts.map((item, index) => (
                    <Fragment key={index}>
                      <tr className="tw-bg-white tw-border-b tw-border-second-zain tw-cursor-pointer">
                        <td
                          colSpan="2"
                          className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-[16px] tw-font-semibold tw-text-gray-900"
                        >
                          {item.name}
                        </td>
                      </tr>
                      {item.Products.map((item2, index2) => (
                        <tr
                          key={index2}
                          className="tw-bg-white tw-border-b tw-cursor-pointer hover:tw-bg-gray-100 hover:tw-border-second-zain"
                        >
                          <td className="tw-text-sm tw-text-gray-900 tw-font-light tw-px-6 tw-py-4 tw-whitespace-nowrap">
                            {item2.product_name}
                          </td>
                          <td className="tw-text-sm tw-text-gray-900 tw-font-light tw-px-6 tw-py-4 tw-whitespace-nowrap">
                            {item2.price}
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  )) 
                  :
                  dataProductsShowErrMsg ?
                  <tr className="tw-bg-red-100 tw-border-b tw-border-second-zain tw-cursor-pointer">
                    <td colSpan="2" className="tw-text-sm tw-text-red-500 tw-font-light tw-px-6 tw-py-4 tw-whitespace-nowrap">
                      {dataProductsErrMsg}
                    </td>
                  </tr>
                  :
                  <tr className="tw-bg-whitw tw-border-b tw-border-second-zain tw-cursor-pointer">
                    <td colSpan="2" className="tw-text-sm tw-text-gray-400 tw-font-light tw-px-6 tw-py-4 tw-whitespace-nowrap">
                      جاري التحميل...
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
};

export default PriceItem;
